// DONE Flag skipped bei getNext / getPreviuous berücksichtigen, damit configurationSteps beim skippen nicht mehr geändert werden muss
// DONE abhängigkeit des StepService von Data wieder auflösen
// DONE Flag skipped -> hidden (direkt in index.html)

angular.module('olivioConfiguratorApp')
	.factory('StepService', function ($rootScope, $window, $location, Model, $translate, env) {
    //console.log('init StepService');

    var configurationSteps = [
      {
        view: 'product',
        nameKey: ('STEPS.PRODUCT'), // Modell
        active: false,
        enabled: true,
        hidden: false,
        skipped: false,
        previous: '',
        next: 'design'
      },
      {
        view: 'design',
        nameKey: ('STEPS.DESIGN'), // Design
        active: false,
        enabled: false,
        hidden: false,
        skipped: false,
        previous: 'product',
        next: 'charging'
      },
      {
        view: 'charging',
        nameKey: ('STEPS.CHARGING'), // Design
        active: false,
        enabled: true,
        hidden: false,
        skipped: false,
        previous: 'design',
        next: 'assembly'
      },
      {
        view: 'assembly',
        nameKey: ('STEPS.ASSEMBLY'), //Bestückung
        active: false,
        enabled: false,
        hidden: false,
        skipped: false,
        previous: 'charging',
        next: 'color'
      },
      {
        view: 'color',
        nameKey: ('STEPS.COLOR'), //Lichtfarbe
        active: false,
        enabled: false,
        hidden: true,
        skipped: false,
        previous: 'assembly',
        next: 'distribution'
      },
      {
        view: 'distribution',
        nameKey: ('STEPS.DISTRIBUTION'), //Lichtverteilung
        active: false,
        enabled: false,
        hidden: true,
        skipped: false,
        previous: 'color',
        next: 'power'
      },
      {
        view: 'power',
        nameKey: ('STEPS.POWER'), //Leistung
        active: false,
        enabled: false,
        hidden: true,
        skipped: false,
        previous: 'color',
        next: 'gobo'
      },
      {
        view: 'gobo',
        nameKey: ('STEPS.GOBOLENS'), //Leistung
        active: false,
        enabled: false,
        hidden: true,
        skipped: false,
        previous: 'power',
        next: 'details'
      },
      {
        view: 'details',
        nameKey: ('STEPS.DETAILS'), //Details
        active: false,
        enabled: false,
        hidden: false,
        skipped: false,
        previous: 'gobo',
        next: 'checkout'
      },
      {
        view: 'checkout',
        nameKey: ('STEPS.CHECKOUT'), // Checkout
        active: false,
        enabled: false,
        hidden: true,
        skipped: false,
        previous: 'details',
        next: ''
      }
    ];


    var stepService = {
      configurationSteps: configurationSteps,
      visibleSteps: [],
      stepsDone: {}
    };



    stepService.updateEnabled = function () {
      // HACK: restrict to assembly=LED only but keep it for old configurations
      var assemblyStep = configurationSteps.filter(s => s.view === 'assembly')[0];
      assemblyStep.hidden = (Model.model.assembly.id === 'led');
      assemblyStep.skipped = assemblyStep.hidden;
      configurationSteps.filter(s => s.view === 'color')[0].hidden = !assemblyStep.hidden;

      // enable all done views and the next view
      // and update visibleSteps and stepsDone
      stepService.visibleSteps = [];
      stepService.stepsDone = {};

      var previousViewDone = true;
      for (var step in configurationSteps) {
        if (!configurationSteps[step].hidden) {
          stepService.visibleSteps.push(configurationSteps[step]);
        }
        if (!configurationSteps[step].skipped) {
          var viewDone = Model.getDone(configurationSteps[step].view);
          configurationSteps[step].enabled = (viewDone && previousViewDone) || previousViewDone;
          previousViewDone = (viewDone && previousViewDone);
          if (viewDone && configurationSteps[step].enabled) {
            stepService.stepsDone[configurationSteps[step].view] = true;
          }
        }
      }
      //console.log('StepService.updateEnabled', configurationSteps, stepService.visibleSteps, stepService.stepsDone);
    };

    // get the data for the current step
    stepService.getCurrentStep = function() {
      return stepService.getStep($location.path().substr(1));
    };

    stepService.getStep = function (id) {
      for (var step in configurationSteps) {
        if (configurationSteps[step].view === id) {
          return configurationSteps[step];
        }
      }
      return false;
    };

    stepService.getNextStep = function() {
      var step = stepService.getCurrentStep();
      do {
        step = stepService.getStep(step.next); // returns false if step.next isn't there
      } while(step && step.skipped);

      return step;
    };

    stepService.getPreviousStep = function() {
      return getStepPreviousTo(stepService.getCurrentStep());
    };

    /**
     * @private
     * @param step step which preceeding step to search
     */
    function getStepPreviousTo(step) {
      do {
        step = stepService.getStep(step.previous);  // returns false if step.next isn't there
      } while(step && step.skipped);

      return step;
    }

    stepService.hasNextStep = function() {
      var nextStep = stepService.getNextStep();
      return nextStep && nextStep.enabled;
    };

    stepService.hasPreviousStep = function() {
      var prevStep = stepService.getPreviousStep();
      return prevStep && prevStep.enabled;
    };

    stepService.nextStep = function() {
      stepService.updateEnabled();

      var nextStep = stepService.getNextStep();
      if (nextStep && nextStep.enabled) {
        $location.path(nextStep.view);
      } else {
        return false;
      }
    };

    stepService.previousStep = function() {
      stepService.updateEnabled();

      var prevStep = stepService.getPreviousStep();
      if (prevStep && prevStep.enabled) {
        $location.path(prevStep.view);
      } else {
        return false;
      }
    };

    stepService.gotoStep = function gotoStep(id) {
      stepService.updateEnabled();

      if (stepService.getStep(id).enabled) {
        $location.path(id);
      } else {
        return false;
      }
    };

    stepService.close = function close($event) {
      if (window.opener) {
        try {
          window.close();
        } catch (ex) {
        }
      } else {
        $location.path('/product/');
      }
    };

    stepService.reset = function ($event) {
      if (Model.getDone("design")) {
        Model.reset();
        stepService.configurationSteps.filter(s => s.view === 'power')[0].skipped = false;
        stepService.updateEnabled();
        $location.path('/');
        $window.location.reload();
      }
    };



		// ---

		// manual update translations. yes twice: first is necessary if parameter lang= is not set in url
    for(var i = configurationSteps.length-1; i>=0; i--) {
      configurationSteps[i].name = $translate(configurationSteps[i].nameKey);
    }
		$rootScope.$on('$translateChangeSuccess', function () {
      for(var i = configurationSteps.length-1; i>=0; i--) {
        configurationSteps[i].name = $translate(configurationSteps[i].nameKey);
        //console.log(i+', '+configurationSteps[i].nameKey+': '+configurationSteps[i].name);
      }
		});

		// do something before route change
		$rootScope.$on('$routeChangeStart', function (event, next, current) {
			// Anmerkung (h): getestet, dass Model.restoreState fertig ist, bevor routeChangeStart aufgerufen wird, next und next.$$route sind immer definiert
//        console.log('$routeChangeStart ' + (current ? current.$$route.id : '--') + ' => ' + (next ? next.$$route.id : '--'));

			// if invalid target search for allowed view
      console.log('on $routeChangeStart', next, next.$$route);
			if (next.$$route !== undefined && next.$$route.id !== undefined && next.$$route.id.substr(1) !== configurationSteps[0].view) { // FIXME testen, eventuell geht es einfach um .redirectTo statt .id
				var step = stepService.getStep(next.$$route.id);
				if (!step || step.skipped || !step.enabled) {
          //stepService.updateEnabled();
					do {
						step = getStepPreviousTo(step);  // tests for skipped
					} while (step && !step.enabled);
				}
				if (step) {
					$location.path('/' + step.view);
				} else {
					$location.path('/' + configurationSteps[0]);
				}
			}
		});
		// show active view after route change
		$rootScope.$on('$routeChangeSuccess', function (event, current, previous) {
			// update active state
      var stepNames = [];
			if (current.$$route !== undefined) {
				for (var step in configurationSteps) {
          configurationSteps[step].active = (current.$$route.id === configurationSteps[step].view);
          stepNames.push(step)
          if(configurationSteps[step].active) {
            ls = stepNames.length - 1;
            while (ls >= 0 && configurationSteps[stepNames[ls]].hidden) {
              ls--;
              configurationSteps[stepNames[ls]].active = true;
            }
          }
				}
			}

		});

    stepService.updateEnabled();

		return stepService;
	})
	.controller('StepCtrl', function ($scope, $route, $routeParams, $location, Model, Data, StepService) {
		//console.log('init StepCtrl');

    $scope.OLIVIO = OLIVIO;
		$scope.model = Model.model;
		$scope.data = Data;
    // HTML can't access StepService without a controller passing it by
    $scope.service = StepService;
    $scope.goboStep = StepService.getStep('gobo');

    //$scope.$watch('model.gobo.individual', function(nV, oV) {
    //  $scope.haveGobo = Model.haveGobo();
    //  console.log('StepCtrl WATCH model.gobo.individual', $scope.haveGobo, $scope.model.gobo.individual);
    //});
    //
    //$scope.$watch('model.gobo.done', function(nV, oV) {
    //  //$scope.haveGobo = Model.haveGobo();
    //  console.log('StepCtrl WATCH model.gobo.done'); //, $scope.haveGobo, $scope.model.gobo.individual);
    //});

		// this creates current.$$route and next.$$route in $rootScope.$on('$routeChangeStart',...) and $rootScope.$on('$routeChangeSuccess', ...)
		$scope.$route = $route;
//      $scope.$location = $location;
		$scope.$routeParams = $routeParams;


	});
